import React, {PureComponent} from 'react';
import cn from 'classnames'
import {connect} from 'react-redux'
import injectSheet from 'react-jss'
import logo from "../img/logo_header.svg"

import Hamburger from "./Hamburger"
import theme from "../styles/theme"
import {UnstyledLink} from "./Widgets/Link"
import {toggleSearchDialog} from '../actions'

import searchImage from "../img/icons/search.svg"
import SVGSymbol from "./SVGSymbol"
import throttle from 'lodash/throttle'
import SingleDropDown from './Widgets/SingleDropDown'
import {getGlobalContent, getCurrentLocation, getSelectedGender, getSelectedGenderLabel, getMenuIsOpen} from '../selectors'
import {selectGender, CONTENT_ROUTE} from '../actions'
import {genderEmpty, genderItems} from "../utils/gender"

let scrollListener;

class Header extends PureComponent {

    componentDidMount() {
        this.lastScrollPosition = 0;
        scrollListener = throttle(this._handleScrollChanged, 200);
        window.addEventListener('scroll', scrollListener);
    }

    componentWillUnmount() {
        if(!scrollListener) return;
        window.removeEventListener('scroll', scrollListener);
        scrollListener = null;
    }

    _handleScrollChanged = () => {
        if(!this._ref ) return;

        const {menuIsOpen} = this.props;

        if(menuIsOpen) {
            this._ref.classList.remove('hide');
            this.lastScrollPosition = window.pageYOffset
            return;
        }

        if(window.pageYOffset  <= this._ref.clientHeight*2) {
            this._ref.classList.remove('hide');
        }
        else {
            if( this.lastScrollPosition - window.pageYOffset < 50 && this.lastScrollPosition - window.pageYOffset > -50) return;

            const scrollingUp = this.lastScrollPosition > window.pageYOffset ;
            if(scrollingUp) this._ref.classList.remove('hide');
            else this._ref.classList.add('hide');
        }

        this.lastScrollPosition = window.pageYOffset
    }

    _onGenderChanged = (selected_gender) => {
        const {handleGenderChanged, gender, location} = this.props;
        if(selected_gender === gender) return;
        handleGenderChanged(selected_gender, location)
    }

    _setRef = (ref) => this._ref = ref;

    _getUrlWithGender = (url, gender) => {
        if(!gender || gender === genderEmpty) return url;
        return url + "?g=" + gender;
    }

    _isMenuSelected = (menu) => {
        const {location} = this.props;
        return location.pathname === menu.url;
    }

    render() {
        const {classes, global, gender, handleOpenSearch, genderLabel} = this.props;

        if(!global) return null;
        return (<header className={classes.header} ref={this._setRef}>
                <UnstyledLink link={{url: global.site_url}} className={classes.logoLink}>
                    <img src={logo} alt="The Iconic Edition" className={classes.logo} />
                </UnstyledLink>
                <div className={classes.mainNavContainer}>
                    <nav>
                        {global.menu && global.menu.length > 0 &&
                        <ul className={classes.mainNav}>
                            {global.menu.map(menu => {
                                return <li className={cn(classes.mainNavItem, {selected: this._isMenuSelected(menu)})} key={menu.url}>
                                    <UnstyledLink link={{
                                        url: this._getUrlWithGender(menu.url, gender),
                                        label: menu.title
                                    }}></UnstyledLink></li>
                            })}
                            {global.search && <li className={classes.mainNavItem}>|</li>}
                            {global.search && <li className={cn(classes.mainNavItem, "strong")}><UnstyledLink
                                link={{url: "https://www.theiconic.com.au/"}}>Shop</UnstyledLink></li>}
                        </ul>
                        }
                    </nav>
                </div>
                {global.search ?
                <div className={classes.menuButtonContainer}>
                    <nav>
                        <ul className={classes.mainNav}>
                            <li>
                                <SingleDropDown label={genderLabel} value={gender} options={genderItems}
                                                title={<div className={classes.genderFilterTitle}>Set Edition preference:</div>}
                                                onChange={this._onGenderChanged}
                                                className={classes.genderFilter}
                                                dropDownClassName={classes.genderFilterDropDown}/>
                            </li>
                            <li className={cn(classes.mainNavItem, 'mobile', 'strong')}><UnstyledLink
                                link={{url: "https://www.theiconic.com.au/"}}>Shop</UnstyledLink></li>
                            <li className={cn(classes.mainNavItem, 'notMobile')}>
                                <a onClick={handleOpenSearch} className={classes.searchIcon} href={global.search_link}>
                                    <SVGSymbol icon={searchImage} ></SVGSymbol></a></li>
                            <li><Hamburger className={classes.hamburger}></Hamburger></li>
                        </ul>
                    </nav>
                </div>
                : <li className={cn(classes.mainNavItem, "strong")}><UnstyledLink
                        link={{url: "https://www.theiconic.com.au/"}}>Shop</UnstyledLink></li>
                }
            </header>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        global: getGlobalContent(state),
        gender: getSelectedGender(state),
        genderLabel: getSelectedGenderLabel(state),
        location: getCurrentLocation(state),
        menuIsOpen: getMenuIsOpen(state)
    }
}

function mapDispatchToProps(dispatch) {
    return {
        handleOpenSearch: (e) => {
            dispatch(toggleSearchDialog())
            e.preventDefault();
        },
        handleGenderChanged: (gender, location) => {
            dispatch(selectGender(gender));
            dispatch( { type: CONTENT_ROUTE, payload: [ location.pathname ], query: { g: gender !== genderEmpty ? gender : undefined} } );
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)( injectSheet(
    {
        header: {
            ...theme.header.height('height'),
            position: 'fixed',
            '-webkit-transform': 'translateZ(0)',
            padding: "1rem 1rem",
            width: "100%",
            backgroundColor: theme.header.backgroundColor,
            color: theme.header.textColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            zIndex: theme.zIndex.header,
            [theme.breakpoint("mobile")]: {
                padding: "1rem 1.2rem",
            },
            transition: 'transform 0.35s ease-in-out',
            '&.hide': {
                transform: 'translate(0, -80px)'
            }
        },
        mainNavContainer: {
            display: "none",
            textAlign: 'center',
            height: '100%',
            flexGrow: 1,
            [theme.breakpoint("tablet")]: {
                display: "block",
            }
        },
        mainNav: {
            display: "flex",
            alignItems: "center",
            justifyContent: 'center'
        },
        mainNavItem: {
            margin: `0 ${theme.spacing.tiny}`,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            '&:after': {
                content: '""',
                width: '0%',
                position: 'absolute',
                left: '50%',
                bottom: -5,
                height: 1,
                backgroundColor: theme.colors.primary,
                transition: 'all 0.3s ease-in-out'
            },
            '&.selected:after': {
                width: '100%',
                left: 0,
            },
            [theme.breakpoint("laptop")]: {
                margin: `0 ${theme.spacing.small}`,
            },
            "& a": {
                color: theme.colors.white,
                textTransform: 'uppercase',
                ...theme.font.menu.normal,
                textDecoration: "none"
            },
            "&.strong": {
                fontWeight: 'bold'
            },
            "&.mobile": {
                display: "flex",
                [theme.breakpoint("tablet")]: {
                    display: 'none',
                }
            },
            '&.notMobile': {
                display: "none",
                [theme.breakpoint("tablet")]: {
                    display: "flex",
                }
            }
        },
        logo: {
            height: 32,
            margin: `0 ${theme.spacing.tiny}`,
            [theme.breakpoint("mobile")]: {
                height: 38,
            },
            [theme.breakpoint("tablet")]: {
                margin: `0 ${theme.spacing.small}`,
            }
        },
        logoLink: {
            width: 200,
            display: "flex",
            color: theme.colors.white,
            textDecoration: "none",
            lineHeight: 1
        },
        shopLink:{
            minHeight: 38,
            minWidth: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: theme.colors.white,
            borderColor: 'rgba(255, 255, 255, 0.35)',
            borderStyle: 'none',
            borderRadius: 2,
            padding: '0.5rem',
            [theme.breakpoint("tablet")]: {
                borderStyle: 'solid',
            },
            [theme.breakpoint("laptop")]: {
                padding: '0.5rem 0.9rem',
            }
        },
        shopLinkContainer: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            whiteSpace: "nowrap",
        },
        searchIcon: {
            marginTop: -2,
            color: theme.colors.white,
            display: 'none',
            "&:hover": {
                color: theme.colors.primary,
            },
            [theme.breakpoint("tablet")]: {
                display: 'inherit',
            },
            "& > svg": {
                width: 16,
                height: 16,
            }
        },
        hamburger: {
            display: "block",
            borderStyle: 'none', //'solid',
            height: 38,
            width: 40,
            [theme.breakpoint("tablet")]: {
                display: "none",
            }
        },
        menuButtonContainer: {
            display: "flex",
            alignItems: "center",
            width: 200,
            height: '100%',
            justifyContent: 'flex-end'
        },
        genderFilter: {
            display: "none",
            marginRight: 10,
            color: theme.colors.white,
            textTransform: 'uppercase',
            ...theme.font.menu.normal,
            fontWeight: 'inherit',
            textDecoration: "none",
            transition: 'color 0.3s ease',
            textAlign: 'right',
            [theme.breakpoint("tablet")]: {
                display: "flex",
            },
        },
        genderFilterDropDown: {
            backgroundColor: 'black',
            color: theme.colors.white,
            marginTop: 5,
            right: -10,
            minWidth: 180,
            textAlign: 'right',
            fontSize: '13px',
            //padding: 20,
            cursor: 'initial',
            "& li": {
                margin: '0'
            },
            "& a": {
                color: theme.colors.white,
                padding: `10px 20px`,
                display: 'block',
                width: '100%',
                position: 'relative',
                "&:after": {
                    content: '""',
                    position: 'absolute',
                    left: 20,
                    width: 10,
                    height: 10,
                    borderWidth: 1,
                    borderStyle: 'solid',
                    borderColor: theme.colors.white,
                    borderRadius: '50%',
                    top: 13
                },
                '&.selected:after': {
                    backgroundColor: theme.colors.primary
                }
            },
            "& li:last-child > a": {
                paddingBottom: 20,
            },
        },
        genderFilterTitle: {
            textAlign: 'left',
            textTransform: 'none',
            padding: `10px 20px`,
        }
})(Header) );



// WEBPACK FOOTER //
// ./src/components/Header.js